import React from 'react';
import styled from 'styled-components';

const HeaderUserDropdownButtonWrapper = styled.div`
  box-sizing: border-box;
  font-size: 1.6rem;
  padding: 0.5em;
  border-radius: 100%;
  width: 4rem;
  height: 4rem;
  color: var(--color-tan_two);
  background-color: var(--color-white);
  cursor: pointer;
  text-decoration: none;
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const HeaderUserDropdownButton = ({ title }) => {
  return (
    <HeaderUserDropdownButtonWrapper>
      <div id="hudb-title">{title}</div>
    </HeaderUserDropdownButtonWrapper>
  );
};

export default HeaderUserDropdownButton;
